var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentToGroup.component,_vm._b({tag:"Component"},'Component',_vm.componentToGroup.data,false))}
var staticRenderFns = []

export { render, staticRenderFns }